import { IReportItem } from "source/models/report/reportItem";
import { Base } from "ui/Scripts/source/framework/base";
import { IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { Translations } from "ui/Scripts/source/models/translations";

export const RiskTypeIdRisk = "00000000-0000-0000-0000-000000000001";
export const RiskTypeIdOpportunity = "00000000-0000-0000-0000-000000000002";

export const RiskStateIdFilterActive = "00000000-0000-0000-0000-000000000001";
export const RiskStateIdFilterdDraft = "00000000-0000-0000-0000-000000000002";
export const RiskStateIdFilterdPublished = "00000000-0000-0000-0000-000000000003";
export const RiskStateIdFilterArchived = "00000000-0000-0000-0000-000000000004";

export const RiskLevelNegligibleFilterdId = "00000000-0000-0000-0000-000000000001";
export const RiskLevelLowFilterdId = "00000000-0000-0000-0000-000000000002";
export const RiskLevelMediumFilterdId = "00000000-0000-0000-0000-000000000003";
export const RiskLevelHighFilterdId = "00000000-0000-0000-0000-000000000004";
export const RiskLevelCriticalFilterdId = "00000000-0000-0000-0000-000000000005";

export const RiskTreatmentStateNotNeededFilterdId = "00000000-0000-0000-0000-000000000005";
export const RiskTreatmentStateTreatmentsSpecifiedFilterdId = "00000000-0000-0000-0000-000000000001";
export const RiskTreatmentStateInProgressFilterdId = "00000000-0000-0000-0000-000000000002";
export const RiskTreatmentStateCompletedFilterdId = "00000000-0000-0000-0000-000000000003";
export const RiskTreatmentStateLateFilterdId = "00000000-0000-0000-0000-000000000004";

/* eslint-disable no-unused-vars */
export const enum RiskHtmlReportId {
    EmployeeRiskReport = "HtmlEmployeeRiskReport",
    ExtensiveRiskReport = "HtmlExtensiveRiskReport",
    TreatmentsRiskReport = "HtmlTreatmentsRiskReport",
}
/* eslint-enable no-unused-vars */

export const riskReportSchema = `{
    "form": {
        "Label1": {
            "type": "label",
            "title": "${Translations.ReportContents}",
            "class": "col-md-12 col-12 fontBold lLabel"
        },
        "FilterCondition": {
            "type": "boolean",
            "title": "${Translations.FilterCondition}",
            "class": "col-md-6 col-6 noTitleInRow",
            "default": "0"
        }
    }
}`;

export const extensiveRiskReportSchema = `{
    "form": {
        "Label1": {
            "type": "label",
            "title": "${Translations.ReportContents}",
            "class": "col-md-12 col-12 fontBold lLabel"
        },
        "FilterCondition": {
            "type": "boolean",
            "title": "${Translations.FilterCondition}",
            "class": "col-md-6 col-6 noTitleInRow",
            "default": "0"
        },
        "RiskRegisterSummary": {
            "type": "boolean",
            "title": "${Translations.RiskRegisterSummary}",
            "class": "col-md-6 col-6 noTitleInRow",
            "default": "1"
        },
        "RiskRegisterDetails": {
            "type": "boolean",
            "title": "${Translations.RiskRegisterDetails}",
            "class": "col-md-6 col-6 noTitleInRow",
            "default": "1"
        },
        "Label2": {
            "type": "label",
            "title": "${Translations.RiskContents}",
            "class": "col-md-12 col-12 fontBold lLabel"
        },
        "RiskTypings": {
            "type": "boolean",
            "title": "${Translations.EventTypesGeneric}",
            "class": "col-6 col-md-6 noTitleInRow printWidth-6",
            "default": "1"
        },
        "Description": {
            "type": "boolean",
            "title": "${Translations.Description}",
            "class": "col-6 col-md-6 noTitleInRow printWidth-6",
            "default": "1"
        },
        "RiskThreat": {
            "type": "boolean",
            "title": "${Translations.RiskThreat}",
            "class": "col-6 col-md-6 noTitleInRow printWidth-6",
            "default": "1"
        },
        "RiskControls": {
            "type": "boolean",
            "title": "${Translations.RiskControls}",
            "class": "col-6 col-md-6 noTitleInRow printWidth-6",
            "default": "1"
        },
        "Assessment": {
            "type": "boolean",
            "title": "${Translations.Assessment}",
            "class": "col-6 col-md-6 noTitleInRow printWidth-6",
            "default": "1"
        },
        "RiskTreatments": {
            "type": "boolean",
            "title": "${Translations.RiskTreatments}",
            "class": "col-6 col-md-6 noTitleInRow printWidth-6",
            "default": "1"
        },
        "Approval": {
            "type": "boolean",
            "title": "${Translations.Approval}",
            "class": "col-6 col-md-6 noTitleInRow printWidth-6",
            "default": "1"
        }
    }
}`;

export interface IRiskPageFilterLists {
    riskTypes: IIdTitle[];
    units: IIdTitleNode[];
    states: IIdTitle[];
    riskCategories: IIdTitleNode[];
    riskProcesses: IIdTitleNode[];
    riskStandards: IIdTitleNode[];
    riskStakeholders: IIdTitleNode[];
    residualRisks: IIdTitle[];
    riskTreatmentStates: IIdTitle[];
    handlers: IIdTitle[];
    owners: IIdTitle[];
}

export interface IRiskPageFilterState {
    selectedRiskTypeIds: string[];
    selectedUnitIds: string[];
    selectedStateIds: string[];
    selectedRiskCategoryIds: string[];
    selectedRiskProcessIds: string[];
    selectedRiskStandardIds: string[];
    selectedRiskStakeholderIds: string[];
    selectedResidualRiskIds: string[];
    selectedRiskTreatmentStateIds: string[];
    selectedHandlerUserCodes: string[];
    selectedOwners: string[];
}

export interface IRiskPageGeneralFilter {
    typeIds: string[];
    unitIds: string[];
    stateIds: string[];
    riskCategoryIds: string[];
    riskProcessIds: string[];
    riskStandardIds: string[];
    riskStakeholderIds: string[];
    residualRiskIds: string[];
    riskTreatmentStateIds: string[];
    handlerUserCodes: string[];
    owners: string[];
}

export interface IRiskPageGeneralFilterChange extends IRiskPageGeneralFilter {
    notChanged: boolean;
}

export const getRiskPageGeneralFilterFromFilterState = (state: IRiskPageFilterState): IRiskPageGeneralFilter => {
    return {
        typeIds: state.selectedRiskTypeIds ? state.selectedRiskTypeIds.filter(i => i !== Base.emptyGuid) : [],
        unitIds: state.selectedUnitIds ? state.selectedUnitIds.filter(i => i !== Base.emptyGuid) : [],
        stateIds: state.selectedStateIds ? state.selectedStateIds.filter(i => i !== Base.emptyGuid) : [],
        riskCategoryIds: state.selectedRiskCategoryIds ? state.selectedRiskCategoryIds.filter(i => i !== Base.emptyGuid) : [],
        riskProcessIds: state.selectedRiskProcessIds ? state.selectedRiskProcessIds.filter(i => i !== Base.emptyGuid) : [],
        riskStandardIds: state.selectedRiskStandardIds ? state.selectedRiskStandardIds.filter(i => i !== Base.emptyGuid) : [],
        riskStakeholderIds: state.selectedRiskStakeholderIds ? state.selectedRiskStakeholderIds.filter(i => i !== Base.emptyGuid) : [],
        residualRiskIds: state.selectedResidualRiskIds ? state.selectedResidualRiskIds.filter(i => i !== Base.emptyGuid) : [],
        riskTreatmentStateIds: state.selectedRiskTreatmentStateIds ? state.selectedRiskTreatmentStateIds.filter(i => i !== Base.emptyGuid) : [],
        handlerUserCodes: state.selectedHandlerUserCodes ? state.selectedHandlerUserCodes.filter(i => !!i) : [],
        owners: state.selectedOwners ? state.selectedOwners.filter(i => !!i) : [],
    };
};

export const getFilterStateFromRiskPageGeneralFilter = (generalFilter: any): IRiskPageFilterState => {
    return {
        selectedRiskTypeIds: generalFilter && generalFilter.typeIds && generalFilter.typeIds.length > 0 ? generalFilter.typeIds : [Base.emptyGuid],
        selectedUnitIds: generalFilter && generalFilter.unitIds && generalFilter.unitIds.length > 0 ? generalFilter.unitIds : [Base.emptyGuid],
        selectedStateIds: generalFilter && generalFilter.stateIds && generalFilter.stateIds.length > 0 ? generalFilter.stateIds : [Base.emptyGuid],
        selectedRiskCategoryIds: generalFilter && generalFilter.riskCategoryIds && generalFilter.riskCategoryIds.length > 0 ? generalFilter.riskCategoryIds : [Base.emptyGuid],
        selectedRiskProcessIds: generalFilter && generalFilter.riskProcessIds && generalFilter.riskProcessIds.length > 0 ? generalFilter.riskProcessIds : [Base.emptyGuid],
        selectedRiskStandardIds: generalFilter && generalFilter.riskStandardIds && generalFilter.riskStandardIds.length > 0 ? generalFilter.riskStandardIds : [Base.emptyGuid],
        selectedRiskStakeholderIds: generalFilter && generalFilter.riskStakeholderIds && generalFilter.riskStakeholderIds.length > 0 ? generalFilter.riskStakeholderIds : [Base.emptyGuid],
        selectedResidualRiskIds: generalFilter && generalFilter.residualRiskIds && generalFilter.residualRiskIds.length > 0 ? generalFilter.residualRiskIds : [Base.emptyGuid],
        selectedRiskTreatmentStateIds: generalFilter && generalFilter.riskTreatmentStateIds && generalFilter.riskTreatmentStateIds.length > 0 ? generalFilter.riskTreatmentStateIds : [Base.emptyGuid],
        selectedHandlerUserCodes: generalFilter && generalFilter.handlerUserCodes && generalFilter.handlerUserCodes.length > 0 ? generalFilter.handlerUserCodes : [""],
        selectedOwners: generalFilter && generalFilter.owners && generalFilter.owners.length > 0 ? generalFilter.owners : [""],
    };
};

export const cloneRiskPageFilterState = (state: IRiskPageFilterState): IRiskPageFilterState => {
    return getFilterStateFromRiskPageGeneralFilter(getRiskPageGeneralFilterFromFilterState(state));
};

export const getRiskPageGeneralFilterNotChanged = (prevFilter: IRiskPageGeneralFilter, filter: IRiskPageGeneralFilter): boolean => {
    return Base.equalStrArrays(prevFilter.typeIds, filter.typeIds) &&
        Base.equalStrArrays(prevFilter.unitIds, filter.unitIds) &&
        Base.equalStrArrays(prevFilter.stateIds, filter.stateIds) &&
        Base.equalStrArrays(prevFilter.riskCategoryIds, filter.riskCategoryIds) &&
        Base.equalStrArrays(prevFilter.riskProcessIds, filter.riskProcessIds) &&
        Base.equalStrArrays(prevFilter.riskStandardIds, filter.riskStandardIds) &&
        Base.equalStrArrays(prevFilter.riskStakeholderIds, filter.riskStakeholderIds) &&
        Base.equalStrArrays(prevFilter.residualRiskIds, filter.residualRiskIds) &&
        Base.equalStrArrays(prevFilter.riskTreatmentStateIds, filter.riskTreatmentStateIds) &&
        Base.equalStrArrays(prevFilter.handlerUserCodes, filter.handlerUserCodes) &&
        Base.equalStrArrays(prevFilter.owners, filter.owners);
};

// export const getRiskPageGeneralFilterChange = (prevProps: IRiskPageFilterState, props: IRiskPageFilterState): IRiskPageGeneralFilterChange => {
//     const prevFilter = getRiskPageGeneralFilterFromFilterState(prevProps);
//     const filter = getRiskPageGeneralFilterFromFilterState(props);
//     return {
//         ...filter,
//         notChanged: getRiskPageGeneralFilterNotChanged(prevFilter, filter)
//     };
// };

export const getRiskPageGeneralFilterChange = (prevFilter: IRiskPageGeneralFilter, props: IRiskPageFilterState): IRiskPageGeneralFilterChange => {
    const filter = getRiskPageGeneralFilterFromFilterState(props);
    return {
        ...filter,
        notChanged: getRiskPageGeneralFilterNotChanged(prevFilter, filter)
    };
};

export const getReportFieldValueNbr = (report: IReportItem, field: string): number | undefined => {
    return report.taskDataRow?.cols.find(col => col.field === field)?.valueNbr;
};

export const getShowFilterCondition = (report: IReportItem): boolean => {
    return getReportFieldValueNbr(report, "FilterCondition") > 0;
};
